import { render, staticRenderFns } from "./localDropdown.vue?vue&type=template&id=64376081&scoped=true&"
import script from "./localDropdown.vue?vue&type=script&lang=js&"
export * from "./localDropdown.vue?vue&type=script&lang=js&"
import style0 from "./localDropdown.vue?vue&type=style&index=0&id=64376081&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64376081",
  null
  
)

export default component.exports